// Auto-refactored from translations.js on 2026-08-19
// Locale: nl

const nl = {
  wieMoeglich: {
    question: 'Hoe is dat mogelijk?',
    answer: 'Wij hebben de waardeketen opnieuw uitgedacht.'
  },
  stigRockWeg: {
    overline: 'STIG ROCK',
    title: 'De STIG ROCK weg',
    fazit: 'Door de verkorte toeleveringsketen vervallen de grootste kostenposten.',
    fazitBigPre: 'Dit maakt een korting mogelijk van maximaal',
    fazitBigValue: '80%',
    steps: [ 'Mijn', 'Slijperij', 'Certificering', 'Eindklant' ]
  },
  nav: { language: 'Taal', contact: 'Contact' },
  hero: {
    overline: 'STIG ROCK — Diamond Solution',
    title: 'Een unieke mogelijkheid',
    subtitle: 'Toekomstgericht vermogen opbouwen.',
    description: 'STIG ROCK is een internationaal platform dat mensen toegang biedt tot natuurlijke diamanten, duurzame vermogensopbouw en een unieke community.',
    scroll: 'Scroll om te ontdekken'
  },
  disclaimer: {
    overline: 'Juridische kennisgeving',
    title: 'Disclaimer',
    paragraphs: [
      'Deze presentatie dient uitsluitend ter informatie en vormt geen financieel, beleggings- of fiscaal advies.',
      'STIG ROCK is geen financieel product, maar heeft betrekking op natuurlijke Diamanten als tastbare activa.',
      'Er wordt geen garantie gegeven voor waardeontwikkelingen, winsten of rendementen. Prestaties uit het verleden zijn geen indicatie voor toekomstige resultaten.',
      'Alle getoonde berekeningen met betrekking tot commissies zijn slechts voorbeelden en vormen eveneens geen garantie.'
    ]
  },
  aufgebaut: {
    overline: 'STIG GROUP',
    titleLines: [ 'GEBOUWD', 'OP STRUCTUUR' ],
    body: 'STIG Group is een internationaal concern, gebouwd op helderheid, verantwoordelijkheid en langetermijnwaarde. Elk merk, elk project en elk partnerschap volgt één enkele standaard — zonder kortere wegen, zonder uitzonderingen.',
    stages: [
      {
        brand: 'STIG GROUP',
        titleLines: [ 'GEBOUWD', 'OP STRUCTUUR' ],
        body: 'STIG Group is een internationaal concern, gebouwd op helderheid, verantwoordelijkheid en langetermijnwaarde. Elk merk, elk project en elk partnerschap volgt één enkele standaard — zonder kortere wegen, zonder uitzonderingen.'
      },
      {
        brand: 'STIG ROCK',
        titleLines: [ 'DE WERELD VAN', 'EXCLUSIEVE DIAMANTEN' ],
        body: 'STIG ROCK is een modern concept van de STIG Group dat hoogwaardige GIA-gecertificeerde Diamanten combineert met transparante structuren en een exclusieve klantervaring. Heldere oplossingsplannen, professionele afwikkeling en een internationale focus.'
      },
      {
        brand: 'STIG INTERNATIONAL',
        titleLines: [ 'INTERNATIONALE', 'DIAMANTHANDEL' ],
        body: 'STIG International is onderdeel van de STIG Group en gespecialiseerd in de internationale handel in GIA-gecertificeerde Diamanten. Focus op kwaliteit, vertrouwen en moderne handelsstructuren met wereldwijde partnerschappen.'
      },
      {
        brand: 'ETHICAL MINES',
        titleLines: [ 'VERANTWOORDELIJKHEID', 'VANAF DE MIJN' ],
        body: 'Ethical Mines staat voor verantwoorde mijnbouw, traceerbare herkomst en conflictvrije Diamanten. Van de mijn tot de markt — volledige documentatie voor transparantie, integriteit en langetermijnverantwoordelijkheid in de gehele toeleveringsketen.'
      }
    ]
  },
  moeglichkeiten: {
    stigLine: 'Diamanten',
    stigDrawback: 'Reële waardeopslag',
    overline: 'Mogelijkheden',
    title: 'Mogelijkheden voor vermogensopbouw',
    subtitle: 'Vergelijking van traditionele wegen.',
    items: [
      {
        tag: 'Trading',
        name: 'Forex of Krypto',
        drawback: 'hoogst speculatief, onvoorspelbaar, complex'
      },
      {
        tag: 'Aktien',
        name: 'Beurshandel',
        drawback: 'schommelingsrisico, vereiste kennis, tijdsintensief'
      },
      {
        tag: 'Krypto',
        name: 'Handel',
        drawback: 'volatiliteit, reguleringsrisico, beveiligingslekken'
      }
    ]
  },
  chance: {
    overline: 'Diamanten',
    title: 'De onderschatte kans',
    body: 'Diamanten behoren al jaren tot de meest waardevaste en kansrijke beleggingsvormen, maar tot nu toe benutten slechts weinigen dit potentieel.',
    callout: 'Met onze STIG ROCK openen we voor het eerst de toegang tot deze buitengewone mogelijkheden voor iedereen.'
  },
  wertentwicklung: {
    overline: 'Waardeontwikkeling 1995 — 2025',
    title: 'Een verhaal over waarde.',
    usd: 'US-Dollar',
    usdValue: '-49%',
    diamond: 'Diamanten',
    diamondValue: '+185%',
    note: 'Ontwikkeling sinds 1995 — 2025'
  },
  hauptgruende: {
    overline: 'Hoofdredenen',
    title: 'Zes redenen voor Diamanten',
    lead: 'Diamanten zijn reële tastbare activa die onafhankelijk van valuta en financiële systemen bestaan — en al eeuwenlang hun waarde behouden.',
    items: [
      {
        n: '01',
        title: 'Crisisbestendige waardevastheid',
        body: 'Garantie op tastbare activa. Onafhankelijk van valuta en financiële systemen.'
      },
      {
        n: '02',
        title: 'De ultieme mobiliteit',
        body: 'Klein, gemakkelijk te verbergen en te transporteren.'
      },
      {
        n: '03',
        title: 'Diversificatie & schaarste',
        body: 'Tekorten in het aanbod en natuurlijke beperkingen.'
      },
      { n: '04', title: 'Groei op lange termijn', body: '+185% sinds 1995.' },
      {
        n: '05',
        title: 'Transparantie & exclusiviteit',
        body: 'De 4 C’s als garantie: Carat, Color, Clarity, Cut.'
      },
      {
        n: '06',
        title: 'Reserve van koningshuizen',
        body: 'Zelfs koningshuizen gebruiken Diamanten als vermogensreserve.'
      }
    ]
  },
  markt: {
    overline: 'Marktvolume',
    title: '99 — 108 Mrd. USD',
    sub: 'Handelsvolume in het jaar 2025',
    forecast: 'Prognose tot ~2032 / 2034: ca. 140 – 168 Mrd. USD bij gematigde groei (~4 – 5 % p.j.).',
    source: 'Bron: Fortune Business Insights'
  },
  innovation: {
    overline: 'Stig International — Innovatie',
    title: 'Een innovatie. Wereldwijd voor de eerste keer.',
    body: 'STIG ROCK is wereldwijd het eerste platform dat mensen in staat stelt een passief inkomen te genereren in de diamantmarkt, naast de waardestijging.',
    hq: 'STIG Gemstone FZCO DMCC — DMCC-1007195',
    hqLines: [
      'STIG Gemstone FZCO DMCC',
      'HDS Business Centre, Cluster M',
      'Jumeirah Lakes Towers — Dubai, VAE',
      'Registernr. DMCC-1007195'
    ],
    team: [
      { name: 'Patrick Stöger', role: 'CEO — Chief Executive Officer' },
      { name: 'Michael Lang', role: 'COO — Chief Operation Officer' }
    ]
  },
  globalNetwork: {
    overline: 'Over de onderneming',
    titleLines: [ 'INTERNATIONALE', 'STRUCTUUR', 'HELDERE VISIE' ],
    body: 'STIG ROCK is opgericht om de diamantmarkt transparanter, moderner en klantgerichter te maken — met een focus op vertrouwen, veiligheid en langetermijnstructuur.'
  },
  sicherheit: {
    overline: 'Kwaliteit & veiligheid',
    title: 'Gemological Institute of America',
    body: 'Gecertificeerde expertise voor uw Diamanten. De GIA beoordeelt elke steen met de hoogste precisie en jarenlange ervaring — betrouwbare taxatierapporten voor ons bedrijf en onze klanten.',
    transparency: 'Elke Diamant voldoet aan de hoogste kwaliteitsnormen en wordt gecontroleerd en gecertificeerd door gerenommeerde organisaties. Elke steen is uniek en krijgt een individueel certificaat.'
  },
  plaene: {
    overline: 'Solution Plannen (SP)',
    title: 'Een unieke productinnovatie',
    sub: 'Zes gestaffelde Solution Plannen — van $1K tot $100K+, elk met een stijgende korting per maand en over de gehele looptijd.',
    recommended: 'Populair',
    oneYear: '1 jaar',
    rowLabels: {
      delivery: 'Levertijd',
      price: 'Productprijs',
      carat: 'Karaat',
      monthly: 'Korting (maand)',
      totalDiscount: 'Korting (totaal)',
      duration: 'Looptijd'
    },
    headers: {
      plan: 'Plan',
      from: 'Vanaf',
      carat: 'Karaat',
      monthly: 'Korting / maand',
      total: 'Korting totaal',
      duration: 'Looptijd'
    },
    duration: '1 jaar',
    footnote: 'Alle prijsopgaven zijn onder voorbehoud en afhankelijk van kwaliteit, vraag en actuele marktontwikkeling. Solution plannen zijn ook voor 2 jaar mogelijk.'
  },
  plaeneVIP: {
    overline: 'Solution Plannen + VIP-pakket',
    title: 'Meer voordelen met het VIP-Paket',
    sub: 'Combineer je Solution Plan met een VIP-Paket en profiteer van extra prijsvoordelen tot 3%. Zo verhoog je je totale korting en verzeker je jezelf van nog aantrekkelijkere condities.',
    rowLabels: {
      delivery: 'Levertijd',
      price: 'Productprijs',
      carat: 'Karaat',
      monthly: 'Korting (maand)',
      totalDiscount: 'Korting (totaal)',
      vip1: 'VIP-pakket 1 (+1%)',
      vip2: 'VIP-pakket 2 (+2%)',
      vip3: 'VIP-pakket 3 (+3%)'
    },
    footnote: 'Alle prijsopgaven zijn onder voorbehoud en afhankelijk van kwaliteit, vraag en actuele marktontwikkeling.'
  },
  moeglichkeitenNach: {
    overline: 'STIG ROCK',
    title: 'Meer voordelen met het VIP-Paket',
    sub: 'Combineer je Solution Plan met een VIP-Paket en profiteer van extra prijsvoordelen tot 3%. Zo verhoog je je totale korting en verzeker je jezelf van nog aantrekkelijkere condities.',
    options: [
      {
        key: 'deliver',
        title: 'Meer voordelen met het VIP-Paket',
        body: 'Diamanten (karaat) voor de prijs van jouw DS-Plan*'
      },
      {
        key: 'sellToUs',
        title: 'Aan ons verkopen',
        body: 'Je kunt jouw Diamanten aan ons terugverkopen voor de door jou betaalde koopprijs.'
      },
      {
        key: 'sellThirdParty',
        title: 'Aan derden verkopen',
        body: 'Je kunt jouw Diamanten doorverkopen aan derden.'
      }
    ],
    footnote: '*DS-Plan staat voor Solution Plan.'
  },
  tradWeg: {
    overline: 'Traditionele handel',
    title: 'De traditionele weg',
    sub: 'Voordat een Diamant de eindklant bereikt, ontstaan er aanzienlijke handelsmarges door tussen-, groot- en detailhandel vergeleken met de ruwe diamantprijs uit de mijn.',
    steps: [
      { title: 'Mijn', subtitle: 'Ruwe Diamanten' },
      { title: 'Tussenhandelaar', subtitle: 'Inkoop ruwe Diamanten' },
      { title: 'Slijperij', subtitle: 'Slijpen tot sieraaddiamanten' },
      { title: 'Certificering', subtitle: 'door erkende instituten zoals GIA' },
      { title: 'Diamantbeurs', subtitle: 'Verkoop aan groothandel' },
      { title: 'Groothandel', subtitle: 'Verkoop aan detailhandel' },
      { title: 'Detailhandel', subtitle: 'bijv. juweliers' },
      { title: 'Eindklanten', subtitle: 'Aankoop van Diamanten' }
    ]
  },
  stigWeg: {
    overline: 'STIG INTERNATIONAL GEMSTONE FZCO',
    title: 'The Dual-Purchase System',
    sub: 'One purchase. Two diamonds. Double value creation.',
    duration: '1 Purchase = 2 Diamonds = Double Value Creation',
    centerBig: '5',
    centerCaption: 'Example: $10,000 purchase = $20,000 total value',
    cycle: [
      {
        n: '1.',
        title: 'Customer Purchase',
        body: 'Customer buys a diamond with processing time, e.g. $10,000.'
      },
      {
        n: '2.',
        title: 'Dual Assignment',
        body: 'Instant and simultaneous: 1 rough diamond for the customer — 100 % their property. 1 rough diamond for the company — financed from the profit.'
      },
      {
        n: '3.',
        title: 'Value Creation',
        body: 'Combined finished sale value of both diamonds: $20,000 — in the portfolio.'
      },
      {
        n: '4.',
        title: 'Active Trading',
        body: 'The company diamond is immediately processed and traded.'
      },
      {
        n: '5.',
        title: 'Further Revenue',
        body: 'Profits flow into mining licenses, the extraction of rough diamonds and the purchase — STIG Ethical Mines.'
      }
    ],
    steps: [
      { title: 'Mine', subtitle: 'Rough diamonds' },
      { title: 'Cutting', subtitle: 'through our partners' },
      { title: 'Certification', subtitle: 'through recognised institutes' },
      { title: 'End customers', subtitle: 'Purchase & discount credits' }
    ],
    footnote: 'Rough diamond: STIG Ethical Mines · Refinement to sale: STIG International Gemstone FZCO'
  },
  vip: {
    overline: 'STIG ROCK',
    title: 'VIP-pakketten',
    sub: '12 maanden geldig op alle door jou afgesloten Solution plannen. Afhankelijk van het VIP-pakket: +1% tot +3% extra korting',
    cardKicker: 'extra – op alle',
    cardKicker2: 'Solution plannen',
    packages: [
      { name: 'VIP 1', price: '$150', bonus: '+1%' },
      { name: 'VIP 2', price: '$500', bonus: '+2%' },
      { name: 'VIP 3', price: '$1.000', bonus: '+3%' }
    ],
    example: {
      title: 'Kortingen worden besparingen',
      body: 'Maandelijkse besparing in plaats van maandelijkse lasten. Uit kortingen ontstaan besparingen – en deze betalen precies de zaken waarvoor je anders elke maand uit eigen zak betaalt.',
      line1Label: 'DS-Plan vanaf',
      line1Value: '$5.000',
      line2Label: 'mnd. korting',
      line2Value: '3%',
      line3Label: 'VIP-pakket 3',
      line3Value: '+3%',
      resultLabel: 'mnd. besparingen',
      resultValue: '$300'
    }
  },
  wertschoepfung: {
    overline: 'Hoe is dit mogelijk?',
    title: 'Wij hebben de waardeketen opnieuw ontworpen.',
    traditionalTitle: 'De traditionele weg',
    traditionalSteps: [
      'Mijn — Ruwe Diamanten',
      'Tussenhandelaar — Inkoop',
      'Slijperij — Slijpen',
      'Certificering (GIA)',
      'Diamantbeurs — Groothandel',
      'Groothandel → Detailhandel',
      'Juweliers → Eindklant'
    ],
    traditionalNote: 'Voordat een Diamant de eindklant bereikt, ontstaan er aanzienlijke handelsmarges door tussen-, groot- en detailhandel.',
    stigTitle: 'De STIG ROCK weg',
    stigSteps: [
      'Directe inkoop — Ruwe Diamanten uit de mijn',
      'Slijpen & certificeren door onze partners',
      'Verkoop aan eindklanten & B2B-klanten',
      'Tot 4 handelscycli per jaar'
    ],
    stigNote: 'Wij doorbreken de cyclus en geven de handelsmarges als kortingstegoeden door aan onze klanten — tot 4 handelscycli tijdens de looptijd van het DS-Plan.'
  },
  optionen: {
    overline: 'Jouw mogelijkheden',
    title: 'Na afloop van je Solution plan',
    items: [
      {
        title: 'Laten leveren',
        body: 'Diamanten (karaat) voor de prijs van jouw DS-Plan.'
      },
      {
        title: 'Aan ons verkopen',
        body: 'Terugverkoop voor de door jou betaalde koopprijs.'
      },
      { title: 'Aan derden verkopen', body: 'Diamanten op de vrije markt verkopen.' }
    ]
  },
  einfacherWeg: {
    overline: 'Solution plannen — een unieke productinnovatie',
    title: 'De eenvoudige weg',
    steps: [
      {
        n: '01',
        icon: 'signup',
        title: 'Aanmelding',
        body: 'Neem contact op met je verwijzer en maak een gratis account aan!'
      },
      { n: '02', icon: 'cart', title: 'Aankoop van een product', body: 'Al vanaf $ 250,-' },
      {
        n: '03',
        icon: 'discount',
        title: 'Kortingen ontvangen',
        body: 'Ontvang maandelijkse kortingstegoeden.'
      }
    ]
  },
  business: {
    overline: 'Bonusvormen',
    title: 'De eenvoudigste en eerlijkste weg.',
    sub: 'Vijf bonusvormen — voor jouw succesvolle bedrijfsopbouw.',
    bonuses: [
      {
        name: 'Unilevel Bonus',
        icon: 'unilevel',
        value: '18%',
        desc: 'Tot niveau 3, vanaf carrièreniveau Pearl / Ruby.'
      },
      {
        name: 'Infinity Bonus',
        icon: 'infinity',
        value: '24%',
        desc: 'Vanaf Sapphire — oneindig diep.'
      },
      {
        name: 'Matching Bonus',
        icon: 'matching',
        value: '5%',
        desc: 'Op de Infinity Bonus – tot niveau 5 · ZONDER kwalificatie.'
      },
      {
        name: 'World Pools',
        icon: 'world',
        value: '3%',
        desc: '3 pools van de wereldwijde omzet.'
      },
      {
        name: 'Rang Bonus',
        icon: 'rank',
        value: '$8.325 Mio.',
        desc: 'Eenmalige bonus in Diamanten (karaat).'
      }
    ]
  },
  unilevel: {
    overline: 'STIG ROCK · Unilevel Bonus',
    title: 'Unilevel Bonus',
    sub: 'Deze bonus wordt aan jou uitbetaald voor elk nieuw afgesloten Solution plan tot in het 3e niveau. Met zeer lage kwalificaties ontgrendel je de afzonderlijke niveaus.',
    total: 'Tot 18% Unilevel Bonus',
    levels: [
      {
        level: 'Niveau 1',
        value: '10%',
        qual: 'vanaf het begin',
        coin: 'image84.png',
        badge: 'Partner'
      },
      {
        level: 'Niveau 2',
        value: '5%',
        qual: 'vanaf carrièreniveau Pearl',
        coin: 'image83.png',
        badge: 'Pearl'
      },
      {
        level: 'Niveau 3',
        value: '3%',
        qual: 'vanaf carrièreniveau Ruby',
        coin: 'image85.png',
        badge: 'Ruby'
      }
    ]
  },
  infinity: {
    overline: 'STIG ROCK · Infinity Bonus',
    title: 'Infinity Bonus',
    sub: 'Vanaf het carrièreniveau Sapphire ben je gekwalificeerd voor ons Infinity Bonusplan. Je ontvangt 3% bonus. Bij elk nieuw carrièreniveau komen er extra percentages bij. Als een partner in jouw team eveneens gekwalificeerd is, ontvang je het verschil van rang tot rang.',
    exampleTitle: 'Voorbeeld',
    exampleRows: [
      { label: 'Jij bent Blue Diamond', value: '12%' },
      { label: 'Jouw partner is Sapphire', value: '3%' }
    ],
    exampleResult: { label: 'Jouw Infinity Bonus', value: '9%' },
    totalNote: 'Totaal tot 24% Infinity Bonus op alle afgesloten Solution plannen in jouw team — oneindig diep.',
    ranks: [
      { name: 'Sapphire', value: '3%', coin: 'image89.png' },
      { name: 'Emerald', value: '6%', coin: 'image90.png' },
      { name: 'Diamond', value: '9%', coin: 'image91.png' },
      { name: 'Blue Diamond', value: '12%', coin: 'image92.png' },
      { name: 'Green Diamond', value: '15%', coin: 'image93.png' },
      { name: 'Purple Diamond', value: '18%', coin: 'image94.png' },
      { name: 'Diamond Elite', value: '21%', coin: 'image96.png' },
      { name: 'Double Diamond Elite', value: '22%', coin: 'image97.png' },
      { name: 'Triple Diamond Elite', value: '23%', coin: 'image98.png' },
      { name: 'Black Diamond', value: '24%', coin: 'image99.png' }
    ]
  },
  matching: {
    overline: 'STIG ROCK · Matching Bonus',
    title: 'Matching Bonus',
    sub: 'Met deze bonus profiteer je van het succes van jouw team. Je ontvangt een Matching Bonus van 5% op de Infinity Bonus van jouw partners — en dat tot in het 5e niveau van jouw team.',
    note: 'Op alle Infinity Bonus-betalingen in jouw team – tot in het 5e niveau. Vanaf het begin – ZONDER kwalificatie.',
    levels: [
      { level: 'Niveau 1', value: '5%' },
      { level: 'Niveau 2', value: '5%' },
      { level: 'Niveau 3', value: '5%' },
      { level: 'Niveau 4', value: '5%' },
      { level: 'Niveau 5', value: '5%' }
    ],
    totalPrefix: 'Totaal tot',
    totalValue: '25%',
    totalSuffix: 'Matching Bonus'
  },
  worldPools: {
    overline: 'STIG ROCK · Worldpools',
    title: 'Worldpools',
    sub: '3% van de wereldwijde omzet vloeit in gelijke delen naar 3 verschillende pools. Door het bereiken van bepaalde carrièreniveaus kwalificeer je je voor elke afzonderlijke pool.',
    forever: 'Eenmaal bereikt – voor ALTIJD deelnemend!',
    pools: [
      { key: 'p1', label: 'Pool 1', value: '1%', qual: 'vanaf Blue Diamond' },
      { key: 'p2', label: 'Pool 2', value: '1%', qual: 'vanaf Purple Diamond' },
      { key: 'p3', label: 'Pool 3', value: '1%', qual: 'vanaf Double Diamond Elite' }
    ],
    ranks: [
      { name: 'Blue Diamond', coin: 'image92.png', shares: [ 1, 0, 0 ] },
      { name: 'Green Diamond', coin: 'image93.png', shares: [ 2, 0, 0 ] },
      { name: 'Purple Diamond', coin: 'image94.png', shares: [ 2, 1, 0 ] },
      { name: 'Diamond Elite', coin: 'image96.png', shares: [ 2, 2, 0 ] },
      { name: 'Double Diamond Elite', coin: 'image97.png', shares: [ 2, 2, 1 ] },
      { name: 'Triple Diamond Elite', coin: 'image98.png', shares: [ 2, 2, 2 ] },
      { name: 'Black Diamond', coin: 'image99.png', shares: [ 2, 2, 3 ] }
    ],
    totalPrefix: 'Totaal',
    totalValue: '3%',
    totalSuffix: 'van de wereldwijde omzet'
  },
  rangBonus: {
    overline: 'STIG ROCK · Rang Bonus',
    title: 'Rang Bonus',
    sub: 'Vanaf het carrièreniveau Diamond ontvang je een Rang Bonus. Deze wordt uitgekeerd in Diamanten (karaat). Het betreft hier een eenmalige bonus.',
    highlight: 'Diamanten (karaat) ter waarde van in totaal',
    totalValue: '$8.325.000',
    ranks: [
      { name: 'Emerald', coin: 'image90.png', value: '' },
      { name: 'Diamond', coin: 'image91.png', value: '$5.000' },
      { name: 'Blue Diamond', coin: 'image92.png', value: '$20.000' },
      { name: 'Green Diamond', coin: 'image93.png', value: '$50.000' },
      { name: 'Purple Diamond', coin: 'image94.png', value: '$100.000' },
      { name: 'Diamond Elite', coin: 'image96.png', value: '$150.000' },
      { name: 'Double Diamond Elite', coin: 'image97.png', value: '$1.000.000' },
      { name: 'Triple Diamond Elite', coin: 'image98.png', value: '$2.000.000' },
      { name: 'Black Diamond', coin: 'image99.png', value: '$5.000.000' }
    ]
  },
  karriere: {
    overline: 'STIG ROCK · Karrierestufen',
    title: 'Carrièreniveaus',
    sub: 'Voor het bereiken van de respectievelijke carrièreniveaus telt de historische totale omzet (HG). Deze moet vanaf het niveau Sapphire over meerdere teams verdeeld zijn. Om Ruby of hoger te bereiken, heb je minimaal twee directe partners met een Solution plan nodig.',
    forever: 'Eenmaal bereikt – voor ALTIJD bevestigd!',
    footnote: 'HV = Historische totale omzet.',
    ranks: [
      { name: 'Partner', coin: 'image84.png', hg: '', perks: [ '1 Unilevel' ] },
      { name: 'Pearl', coin: 'image83.png', hg: '250 HV', perks: [ '2 Unilevels' ] },
      {
        name: 'Ruby',
        coin: 'image85.png',
        hg: '500 HV',
        perks: [ '2 dir. Pearl', '3 Unilevels' ]
      },
      {
        name: 'Sapphire',
        coin: 'image89.png',
        hg: '25.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 3%' ]
      },
      {
        name: 'Emerald',
        coin: 'image90.png',
        hg: '50.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 6%' ]
      },
      {
        name: 'Diamond',
        coin: 'image91.png',
        hg: '250.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 9%', '$5k Bonus' ]
      },
      {
        name: 'Blue Diamond',
        coin: 'image92.png',
        hg: '1.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 12%', '$20k Bonus', '1 Pool' ]
      },
      {
        name: 'Green Diamond',
        coin: 'image93.png',
        hg: '2.500.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 15%', '$50k Bonus', '1 Pool' ]
      },
      {
        name: 'Purple Diamond',
        coin: 'image94.png',
        hg: '5.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 18%', '$100k Bonus', '2 Pools' ]
      },
      {
        name: 'Diamond Elite',
        coin: 'image96.png',
        hg: '10.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 21%', '$150k Bonus', '2 Pools' ]
      },
      {
        name: 'Double Diamond Elite',
        coin: 'image97.png',
        hg: '50.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 22%', '$1M Bonus', '3 Pools' ]
      },
      {
        name: 'Triple Diamond Elite',
        coin: 'image98.png',
        hg: '150.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 23%', '$2M Bonus', '3 Pools' ]
      },
      {
        name: 'Black Diamond',
        coin: 'image99.png',
        hg: '500.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 24%', '$5M Bonus', '3 Pools' ]
      }
    ]
  },
  cta: {
    overline: 'Start met ons door',
    title: 'Het juiste moment is nu.',
    body: 'Dit businessmodel stelt nieuwe normen en verenigt alle succesfactoren voor een duurzame en succesvolle onderneming op lange termijn. Registreer je vandaag nog, kies je Solution plan en maak gebruik van deze unieke zakelijke kans.',
    hint: 'Spreek met de persoon die je voor deze presentatie heeft uitgenodigd — deze heeft een registratielink voor je.',
    formName: 'Naam',
    formEmail: 'E-mail',
    formPhone: 'Telefoon',
    formSubmit: 'Contact opnemen',
    success: 'Hartelijk dank — wij nemen discreet en persoonlijk contact op.',
    callCta: 'Bellen',
    whatsapp: 'WhatsApp'
  },
  footer: {
    disclaimerTitle: 'Juridische kennisgeving & Disclaimer',
    disclaimer: 'Deze presentatie dient uitsluitend ter informatie en vormt geen financieel, beleggings- of fiscaal advies. STIG ROCK is geen financieel product, maar heeft betrekking op natuurlijke Diamanten als tastbare activa. Er wordt geen garantie gegeven voor waardeontwikkelingen, winsten of rendementen. Prestaties uit het verleden zijn geen indicatie voor toekomstige resultaten. Alle getoonde berekeningen met betrekking tot commissies zijn slechts voorbeelden en vormen eveneens geen garantie. Wijzigingen in de inhoud voorbehouden — vrije vertaling (geen officiële vertaling).',
    hq: 'HDS Business Centre — Jumeirah Lakes Towers — Dubai, VAE',
    copy: '© 2026 STIG International. Alle rechten voorbehouden.',
    version: 'Versie: DS-12-2025 V3'
  },
  misc: { next: 'Volgende sectie' }
};

export default nl;
